import t from 'tcomb';
import Date_Schema from '../../web/domain/Date_Schema';
import jsdk from '../../jsdk';

const Date_Input = t.struct({
  id: t.Str,
  is_accurate: t.maybe(t.Bool),
  schema: Date_Schema,
  attrs: t.maybe(t.Obj),
  hint: t.maybe(t.Str)
}, 'Date_Input');


/*
function Date_Input(id, is_accurate, schema, attrs, hint) {
  assert(Str.is(id));
  assert(Maybe(Bool).is(is_accurate));
  assert(Date_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'date';
  this.id = id;
  this.is_accurate = is_accurate;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}



Date_Input.is = function(x) {
  return x instanceof Date_Input;
};

Date_Input.of = function(x) {
  assert(Obj.is(x));
  return new Date_Input(
    Str.of(x.id),
    Maybe(Bool).of(x.is_accurate),
    Date_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};
*/
Date_Input.prototype.to_html = function(value, locale) {
  //t.assert(t.maybe(JSON_Value).is(value));
  //t.assert(Locale.is(locale));
  var id = this.id;
  var order = this.is_accurate ?
    locale.locale_bundle().date.accurate_order :
    locale.locale_bundle().date.order;
  var attrs = !t.Nil.is(this.attrs) ? jsdk.copy(this.attrs) : {};
  attrs.id = id;
  var styles = jsdk.split_margins(attrs.style);
  attrs.style = styles.other;
  return jsdk.Form.wrap_input(id, jsdk.date(attrs, value, order), styles.margins, this.hint);
};

Date_Input.prototype.focus = function() {
  $('#' + this.id).children().get(0).focus();
};

Date_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Date_Input.prototype.value = function(locale) {
  //t.assert(Locale.is(locale));
  var id = this.id;
  var value = [
    $('#' + id + " .years").val(),
    $('#' + id + " .months").val(),
    $('#' + id + " .days").val()
  ];
  if (this.is_accurate) {
    value.push(
      $('#' + id + " .hours").val(),
      $('#' + id + " .minutes").val()
    );
  }
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

jsdk.Form.add_input('date', Date_Input);


export default Date_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/base/Date_Input.js
 **/